import { Small } from "@fronterahealth/frontera-ui-components";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { getCommentAuthor } from "@components/QaReview/components/commentAuthor";
import { QUALITY_REVIEW_SOURCE, getSuggestionIcon } from "@components/QaReview/components/suggestionIcon";

// A QA suggestion is headed by the check that raised it; the badge names the source.
const headline = (comment: ReviewItemFieldsFragment): string => {
  const author = getCommentAuthor(comment);
  if (author) return author.name;
  const category = comment.__typename === "ReportSuggestionType" ? comment.category : "";
  return getSuggestionIcon(category).label.trim() || QUALITY_REVIEW_SOURCE;
};

export const AuthorName: React.FC<{ comment: ReviewItemFieldsFragment }> = ({ comment }) => (
  <Small className="font-medium text-text-primary">{headline(comment)}</Small>
);
